import React, { useEffect, useState, useRef, useMemo } from "react";

import AgentLayout from "../components/AgentLayout";
import NavButton from "../components/NavButton";
import DatePickerComponent from "../../client/components/DatePickerComponent";
import EasyGrid from "../../client/components/EasyGrid";
import axiosInstance from "../../../utils/axiosInstance";
import { useDispatch, useSelector } from "react-redux";
import Bootstrap4DatePickerComponent from "../../client/components/Bootstrap4DatePickerComponent";
import $ from "jquery";
import ReactDOM1 from "react-dom/client";
//import BetDetailsPopup from "../components/BetDetailsPopup";
import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";

import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";
import PlbyHierarchicalPopup from "../../agent/reports/PlbyHierarchicalPopup";
//plby-hierarchical

function toLocalString(d) {
  const pad = (x) => String(x).padStart(2, "0");
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
    `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  );
}
const Commission = () => {
  // var today = new Date();
  // var day =
  //   today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();

  // const todayDate = new Date(`${day}T00:00:00.000Z`);
  // const end = new Date(`${day}T23:59:59.999Z`);

  // const [startDate, setStartDate] = useState(todayDate);
  // const [endDate, setEndDate] = useState(end);

  const [gridKey, setGridKey] = useState(Date.now());
  const [gridKey2, setGridKey2] = useState(Date.now());
  const [gridKey3, setGridKey3] = useState(Date.now());

  const today = new Date();
  const year = today.getFullYear();
  const monthIndex = today.getMonth(); // 0-based: 0 = Jan
  const dayOfMonth = today.getDate();

  const todayStart = new Date(year, monthIndex, dayOfMonth, 0, 0, 0, 0);
  const todayEnd = new Date(year, monthIndex, dayOfMonth, 23, 59, 59, 999);

  const [startDate, setStartDate] = useState(todayStart);
  const [endDate, setEndDate] = useState(todayEnd);

  const startDateSet = (date) => {
    setStartDate(date);
  };

  const endDateSet = (date) => {
    setEndDate(date);
  };

  const [masterLevel, setMasterLevel] = useState([]);
  const [masterTotal, setMasterTotal] = useState(0);
  const [profitLossDataLoad, setProfitLossDataLoad] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  const [eventDetailsDisplay, setEventDetailsDisplay] = useState(false);
  const [detailsUsername, setDetailsUsername] = useState("");
  const [detailsMarketTitle, setDetailsMarketTitle] = useState("");

  const userInfo = useSelector((state) => state.userStore);

  let username = "";
  if (
    userInfo !== null &&
    userInfo !== undefined &&
    userInfo.data !== null &&
    userInfo.data !== undefined
  ) {
    username = userInfo.data.uname;
  }

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const getComissionDetails = async (date) => {
    // let frm = startDate;
    // let til = endDate;

    let frm = toLocalString(startDate);
    let til = toLocalString(endDate);
    setShowLoader(true);
    setEventDetailsDisplay(false);

    const response = await axiosInstance.post("master/commission-by-date", {
      frm,
      til
    });
    if (response.status === 200) {
      const resData = response.data;
      const items = resData.master_level || [];

      // Calculate total from all winAmount values (mirrors PHP eval-based sum)
      const total = items.reduce(
        (sum, obj) => sum + Number(obj.total_commission || 0),
        0
      );

      setMasterLevel(items);
      setMasterTotal(total);
      setProfitLossDataLoad(true);
      setShowLoader(false);
      setIsLoading(false);
      setGridKey(Date.now());
      setPlDataDetails([]);
      setSportwiseCommissionTotal(null);
    }
  };

  const [filteredPlData, setFilteredPlData] = useState(null);
  const [plData, setPlData] = useState([]);
  const [plDataDetails, setPlDataDetails] = useState([]);
  /** Sum of `amount` for second grid (by-type)*/
  const [sportwiseCommissionTotal, setSportwiseCommissionTotal] =
    useState(null);

  const betDetailsView = async (id) => {
    const popup = window.open(
      "/bet-details-view/" + id,
      "",
      "width=700,height=500"
    );
    if (popup) {
      popup.document.title = "BPEXCH";
    }
  };

  const betDetailsVirtualView = async (id) => {
    const popup = window.open(
      "/virtual-details-view/" + id,
      "",
      "width=700,height=500"
    );
    if (popup) {
      popup.document.title = "BPEXCH";
    }
  };

  const openPopUp = async (id) => {
    const popup = window.open(
      "/plby-hierarchical/" + id,
      "",
      "width=700,height=500"
    );
    if (popup) {
      popup.document.title = "BPEXCH";
      //  const rootEl = popup.document.createElement("div");
      //  popup.document.body.appendChild(rootEl);

      //  //render React component in new window
      // const root = ReactDOM1.createRoot(rootEl);
      // root.render(<PlbyHierarchicalPopup />);
    }
  };

  const handleClickDetails = async (row) => {
    if (row.user_role == 8) {
      if (row.game_type == 9) {
        betDetailsVirtualView(row.id);
      } else {
        betDetailsView(row.id);
      }
    } else {
      openPopUp(row.id);
    }
  };
  const handleUserClick = async (user) => {
    //let frm = startDate;
    //let til = endDate;
    let frm = toLocalString(startDate);
    let til = toLocalString(endDate);

    setShowLoader(true);
    setDetailsUsername(user.uname);
    setSportwiseCommissionTotal(null);
    const response = await axiosInstance.post(
      "master/commission-by-date/by-type",
      {
        userId: user.user_id,
        frm,
        til
      }
    );
    setPlDataDetails([]);
    const items = Array.isArray(response.data)
      ? response.data
      : response.data.master_level || [];
    const mapped = items.map((item, idx) => ({
      ...item,
      _id: item._id ?? `${item.market_name}_${idx}_${Math.random()}`
    }));
    const byTypeTotal = mapped.reduce((sum, row) => {
      const n = Number(row.amount ?? row.total_commission ?? 0);
      return sum + (Number.isNaN(n) ? 0 : n);
    }, 0);
    setPlData(mapped);
    setSportwiseCommissionTotal(byTypeTotal);

    setShowLoader(false);
    setEventDetailsDisplay(true);
    setGridKey2(Date.now());
  };
  const handleUserClick3 = async (user) => {
    let frm = toLocalString(startDate);
    let til = toLocalString(endDate);

    setShowLoader(true);
    setDetailsMarketTitle(user.game_type_txt || "");
    const response = await axiosInstance.post(
      "master/commission-by-date/by-market-type",
      {
        userId: user.user_id,
        game_type: user.game_type,
        market_type: user.market_type,
        frm,
        til
      }
    );

    const detailItems = Array.isArray(response.data)
      ? response.data
      : response.data.betList || [];
    setPlDataDetails(
      detailItems.map((item, idx) => ({
        ...item,
        _id: item._id ?? item.tid ?? `${item.event}_${idx}_${Math.random()}`
      }))
    );

    setShowLoader(false);

    setGridKey3(Date.now());
  };

  // Adding datatable below:

  const [isLoading, setIsLoading] = useState(true);

  const [pageSize, setPageSize] = useState(10);
  const gridTableRef = useRef(null);
  const gridTableRef2 = useRef(null);
  const defaultExpand = true;
  function escapeHtml(str = "") {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }
  const cols = useMemo(
    () => [
      {
        title: "Name",
        data: "uname",
        responsivePriority: 1,
        render: function (d, type, row) {
          const safe = escapeHtml(String(d ?? ""));
          const key = escapeHtml(String(row._dt_key ?? ""));
          return `<a href="#" class="dt-user-link site_family" data-row-key="${key}" style="color:#00b181;cursor:pointer">${safe}</a>`;
        }
      },
      {
        title: "Amount",
        data: "total_commission",
        render: (d) =>
          d < 0
            ? `<span style="color:red" class="site_family">${formatTruncate(
                Math.round(d)
              )}</span>`
            : `<span style="color:#00b181" class="site_family">${formatTruncate(
                Math.round(d)
              )}</span>`,
        responsivePriority: 2
      },
      {
        title: "",
        data: "id",
        visible: false,
        render: (d) => `<span class="site_family">${d}</span>`,
        responsivePriority: 3
      }
    ],
    []
  );

  const cols3 = useMemo(
    () => [
      {
        title: "Title",
        data: "game_type_txt",
        responsivePriority: 1,
        render: function (d, type, row) {
          const safe = escapeHtml(String(d ?? ""));
          const key = escapeHtml(String(row._dt_key ?? ""));
          return `<a href="#" class="dt-user-link site_family" data-row-key="${key}" style="color:#00b181;cursor:pointer">${safe}</a>`;
        }
      },
      {
        title: "Amount",
        data: "amount",
        render: (d) =>
          d < 0
            ? `<span style="color:red" class="site_family">${formatTruncate(
                Math.round(d)
              )}</span>`
            : `<span style="color:#00b181" class="site_family">${formatTruncate(
                Math.round(d)
              )}</span>`,
        responsivePriority: 2
      },
      {
        title: "",
        data: "id",
        visible: false,
        render: (d) => `<span class="site_family">${d}</span>`,
        responsivePriority: 3
      }
    ],
    []
  );

  const colsDetails = useMemo(
    () => [
      {
        title: "Event",
        data: "event",
        responsivePriority: 1,
        render: function (d, type, row) {
          const safe = escapeHtml(String(d ?? ""));
          const key = escapeHtml(String(row._dt_key ?? ""));
          return `${safe}`;
        }
      },
      {
        title: "Amount",
        data: "amount",
        responsivePriority: 2,
        render: (d) =>
          d < 0
            ? `<span style="color:red" class="site_family">${formatTruncate(
                Math.round(d)
              )}</span>`
            : `<span style="color:#00b181" class="site_family">${formatTruncate(
                Math.round(d)
              )}</span>`
      }
    ],
    []
  );

  return (
    <AgentLayout>
      <style>{`.react-datepicker-popper {
             left: unset;
        }
        @media (max-width: 640px) {
          #ReportFilterForm .row > .col-12.col-md-5 {
            flex: 0 0 100%;
            max-width: 100%;
            margin-bottom: 8px;
          }
          #ReportFilterForm .row > .col-12.col-md-5 .react-datepicker-wrapper,
          #ReportFilterForm .row > .col-12.col-md-5 .react-datepicker__input-container,
          #ReportFilterForm .row > .col-12.col-md-5 .form-group,
          #ReportFilterForm .row > .col-12.col-md-5 .input-group {
            width: 100% !important;
          }
          #ReportFilterForm .row > .col-12.col-md-5 .input-group .form-control {
            flex: 1;
          }
          #ReportFilterForm .row > .col-12.col-md-5 .input-group-addon {
            display: flex;
            align-items: center;
          }
          #ReportFilterForm .input-group {
            flex-wrap: nowrap !important;
          }
          #ReportFilterForm .input-group .input-group-addon {
            display: flex;
            align-items: stretch;
          }
          #ReportFilterForm .input-group .input-group-addon .input-group-text {
            display: flex;
            align-items: center;
            align-self: stretch;
            height: auto;
            padding: 0 0.75rem;
            background-color: #e9ecef;
            border: 1px solid #ced4da;
            border-left: none;
            border-radius: 0 0.25rem 0.25rem 0;
          }
          #ReportFilterForm .input-group .form-control {
            border-radius: 0.25rem 0 0 0.25rem;
          }
          #ReportFilterForm .row > strong {
            display: none;
          }
          #ReportFilterForm .row > .editsbmtbtn {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            padding-right: 20px;
          }
        }`}</style>
      <div className="container-fluid">
        <div
          className="loaderAgent"
          style={{ display: showLoader ? "" : "none" }}
        >
          <img src="/assets/images/loadinggif.gif" />
        </div>

        <div className="bets-section-wrapper">
          <div>
            <NavButton></NavButton>
          </div>
          {/* <button
            className="btn btn-success"
            style={{ background: "#02b181" }}
            type="button"
            onclick="updateFinalSheet()"
          >
            <strong>Update Final Sheet</strong>
          </button>
        */}

          <div>
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <i className="fa fa-filter"></i>
                    <strong className="site_family">Report Filter</strong>
                  </div>
                  <div
                    className="card-body"
                    style={{ padding: "0.8rem 1.25rem" }}
                  >
                    <form
                      id="ReportFilterForm"
                      className="form-inline"
                      method="get"
                    >
                      <div className="row" style={{ textAlignLast: "justify" }}>
                        <div className="col-12 col-md-5">
                          <Bootstrap4DatePickerComponent
                            pickerId="ReportFrom"
                            inputId="DisplayFrom"
                            defaultDate={startDate}
                            setSelectedDate={startDateSet}
                          />

                          {/*<DatePickerComponent
                            defaultDate={startDate}
                            setSelectedDate={startDateSet}
                        />*/}
                        </div>
                        <strong style={{ margin: "auto" }}>
                          &nbsp;-&nbsp;
                        </strong>
                        <div className="col-12 col-md-5">
                          <Bootstrap4DatePickerComponent
                            pickerId="ReportTo"
                            inputId="DisplayTo"
                            defaultDate={endDate}
                            setSelectedDate={endDateSet}
                          />

                          {/*<DatePickerComponent
                            defaultDate={endDate}
                            setSelectedDate={endDateSet}
                      />*/}
                        </div>
                        <div className="form-group editsbmtbtn">
                          <button
                            onClick={() => getComissionDetails()}
                            className="btn btn-success"
                            style={{ background: "#02b181" }}
                            type="button"
                          >
                            <strong className="site_family">Submit</strong>
                          </button>
                        </div>
                      </div>
                      <div className="row col-12"></div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="bets-wrapper"
          style={{
            marginTop: "0px",
            display: profitLossDataLoad ? "" : "none"
          }}
        >
          <div className="row">
            <div className="col-md-6" style={{ marginTop: "0px" }}>
              <div className="card">
                <div className="card-header">
                  <div style={{ float: "left" }}>
                    <i className="fa fa-align-justify"></i>
                    <span style={{ fontWeight: "600" }} className="site_family">
                      {" "}
                      Commission Report
                    </span>
                  </div>
                  <div style={{ float: "right" }}>
                    {" "}
                    <span
                      className="loader"
                      id="span_loader_report"
                      style={{ top: "10px", left: "10px", display: "none" }}
                    ></span>
                  </div>
                </div>
                <div className="card-body">
                  <div className="col-12">
                    <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                      <div className="row">
                        <div className="col-sm-12">
                          <div
                            className="site_family"
                            style={{ marginBottom: "1rem", fontSize: "1rem" }}
                          >
                            All Commission goes to As per share (Auto
                            Commission)
                          </div>
                          {masterLevel.length > 0 && (
                            <div>
                              <EasyGrid
                                responsiveMode="hybrid"
                                cols={cols}
                                dataset={masterLevel}
                                isLoading={isLoading}
                                pageSize={pageSize}
                                handleUserClick={handleUserClick}
                              ></EasyGrid>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <table className="table table-sm dataTable">
                      <tbody>
                        <tr
                          style={{
                            background: masterTotal < 0 ? "#f86d6b" : "#02b180",
                            color: "white"
                          }}
                        >
                          <td
                            style={{
                              padding: "8px",
                              fontWeight: 600,
                              fontWeight: "bold"
                            }}
                            className="site_family"
                          >
                            Total
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              fontWeight: 600,
                              fontWeight: "bold",
                              textAlign: "left"
                            }}
                            className="site_family"
                          >
                            {formatTruncate(masterTotal)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-md-6"
              style={{
                marginTop: "3px",
                display: eventDetailsDisplay ? "" : "none"
              }}
            >
              <div>
                <div className="card">
                  <div className="card-header">
                    <div style={{ float: "left" }}>
                      <i className="fa fa-align-justify"></i>
                      <span
                        style={{ fontWeight: "bold", paddingLeft: "10px" }}
                        className="site_family"
                      >
                        {detailsUsername}
                      </span>
                      <span className="site_family">- Sportwise Report</span>
                    </div>
                  </div>
                  <div className="card-body">
                    {plData.length > 0 && (
                      <div>
                        <EasyGrid
                          responsiveMode="hybrid"
                          cols={cols3}
                          dataset={plData}
                          isLoading={isLoading}
                          pageSize={pageSize}
                          handleUserClick={handleUserClick3}
                        ></EasyGrid>
                      </div>
                    )}
                    {eventDetailsDisplay &&
                      sportwiseCommissionTotal !== null && (
                        <table className="table table-sm dataTable">
                          <tbody>
                            <tr
                              style={{
                                background:
                                  sportwiseCommissionTotal < 0
                                    ? "#f86d6b"
                                    : "#02b180",
                                color: "white"
                              }}
                            >
                              <td
                                style={{
                                  padding: "8px",
                                  fontWeight: 600,
                                  fontWeight: "bold"
                                }}
                                className="site_family"
                              >
                                Total
                              </td>
                              <td
                                style={{
                                  padding: "8px",
                                  fontWeight: 600,
                                  fontWeight: "bold",
                                  textAlign: "left"
                                }}
                                className="site_family"
                              >
                                {sportwiseCommissionTotal.toLocaleString()}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      )}
                  </div>
                </div>
              </div>
              <div style={{ marginTop: "20px", display: "" }}>
                {plDataDetails.length > 0 && (
                  <div className="card">
                    <div className="card-header">
                      <div style={{ float: "left" }}>
                        <i className="fa fa-align-justify"></i>
                        <span className="site_family">
                          {" "}
                          {detailsUsername} / {detailsMarketTitle} Markets
                          Reports
                        </span>
                      </div>
                    </div>
                    <div className="card-body">
                      {plDataDetails.length > 0 && (
                        <div>
                          <EasyGrid
                            responsiveMode="hybrid"
                            cols={colsDetails}
                            dataset={plDataDetails}
                            isLoading={isLoading}
                            pageSize={pageSize}
                            handleUserClick={handleClickDetails}
                          ></EasyGrid>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <style>{`

.loaderAgent {
   
  position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    opacity: .6;
    display: flex;
    justify-content: center;
    align-items: center; 
  background-image:
      linear-gradient(#000 20px, transparent 0),
      linear-gradient(#000 20px, transparent 0),
      linear-gradient(#000 20px, transparent 0),
      linear-gradient(#000 20px, transparent 0);
  background-repeat: no-repeat;
  background-size: 20px auto;
  background-position: 0 0, 40px 0, 80px 0, 120px 0;
  animation: pgfill 1s linear infinite;
}

@keyframes pgfill {
  0% {
      background-image: linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0);
  }

  25% {
      background-image: linear-gradient(#ddae29 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0);
  }

  50% {
      background-image: linear-gradient(#000 20px, transparent 0), linear-gradient(#ddae29 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0);
  }

  75% {
      background-image: linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#ddae29 20px, transparent 0), linear-gradient(#000 20px, transparent 0);
  }

  100% {
      background-image: linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#ddae29 20px, transparent 0);
  }
}

`}</style>
      </div>
    </AgentLayout>
  );
};

export default Commission;